import { useCallback } from "react";

import {
  copyCollectionLink,
  sendCollectionToTwitter,
  sendCollectionToReddit,
  getCollectionEmbedCode,
} from "utils/share";

import { ShareMenu } from "./ShareMenu";

interface IShareCollectionMenuProps {
  userName: string;
  collectionId: string;
  collectionName: string;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  fullscreen?: boolean;
}

export const ShareCollectionMenu = (props: IShareCollectionMenuProps) => {
  const { userName, collectionId, collectionName, anchorEl, onClose, fullscreen = false } = props;

  const handleClick = useCallback(async (label: string) => {
    if (label === "Copy Link" || label === "Discord") {
      await copyCollectionLink(userName, collectionId);
    } else if (label === "Reddit") {
      sendCollectionToReddit(userName, collectionId);
    } else if (label === "Twitter") {
      sendCollectionToTwitter(userName, collectionId);
    }

    onClose();
  }, [userName, collectionId, onClose]);

  return (
    <ShareMenu
      anchorEl={anchorEl}
      onClick={handleClick}
      onClose={onClose}
      fixedEmbedCode={getCollectionEmbedCode(userName, collectionId, collectionName)}
      responsiveEmbedCode={getCollectionEmbedCode(userName, collectionId, collectionName)}
      fullscreen={fullscreen}
    />
  );
};
